// This is forked from https://github.com/avadhesh18/iosPWASplash
function generate(iconUrl, bgColor = "white") {
  if (window.iosPWASplashAddedUrl === iconUrl) return

  if (typeof iconUrl !== "string" || iconUrl.length === 0)
    throw Error("Invalid icon URL provided")

  const screenW = screen.width,
    screenH = screen.height,
    pixelRatio = window.devicePixelRatio || 1

  // create portrait & landscape canvases in device pixels
  const portraitCanvas = document.createElement("canvas"),
    landscapeCanvas = document.createElement("canvas"),
    pCtx = portraitCanvas.getContext("2d"),
    lCtx = landscapeCanvas.getContext("2d"),
    img = new Image()

  img.crossOrigin = "anonymous"
  img.onerror = () => {
    throw Error("Failed to load icon image")
  }

  img.onload = () => {
    // 1) compute base icon size (as original lib does)
    const baseW = img.width / (3 / pixelRatio)

    // 2) clamp width to 50% of screen width (in device-px)
    const canvasW = screenW * pixelRatio
    const canvasH = screenH * pixelRatio
    const maxIconW = canvasW * 0.5
    const iconW = Math.min(baseW, maxIconW)
    const iconH = iconW * (img.height / img.width)

    // 3) set up canvas sizes (portrait & landscape)
    portraitCanvas.width = canvasW
    portraitCanvas.height = canvasH
    landscapeCanvas.width = canvasH
    landscapeCanvas.height = canvasW

    // 4) fill backgrounds
    pCtx.fillStyle = bgColor
    pCtx.fillRect(0, 0, canvasW, canvasH)
    lCtx.fillStyle = bgColor
    lCtx.fillRect(0, 0, canvasH, canvasW)

    // 5) center & draw icon
    const px = (canvasW - iconW) / 2,
      py = (canvasH - iconH) / 2,
      lx = (canvasH - iconW) / 2,
      ly = (canvasW - iconH) / 2

    pCtx.drawImage(img, px, py, iconW, iconH)
    lCtx.drawImage(img, lx, ly, iconW, iconH)

    // 6) inject the two startup-image links
    const portraitLink = document.createElement("link")

    portraitLink.rel = "apple-touch-startup-image"
    portraitLink.media = "screen and (orientation: portrait)"
    portraitLink.href = portraitCanvas.toDataURL("image/png")
    document.head.appendChild(portraitLink)

    const landscapeLink = document.createElement("link")

    landscapeLink.rel = "apple-touch-startup-image"
    landscapeLink.media = "screen and (orientation: landscape)"
    landscapeLink.href = landscapeCanvas.toDataURL("image/png")
    document.head.appendChild(landscapeLink)
  }

  img.src = iconUrl
  window.iosPWASplashAddedUrl = iconUrl
}

export { generate }
